<template>
    <div id="app">
<!--        <QrScanLogin/>-->
        <router-view />
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import {UUID} from "@/store/mutation-types";
export default {
    name: 'App',
    components: {
    },
    metaInfo: {
        title: "SHIMARS",
        meta: [
            {name: "viewport", content: "width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"},
        ],
    },
    mounted () {
        let uuid=''
        if(localStorage.getItem(UUID)){
            uuid=localStorage.getItem(UUID)
            console.log('old uuid:'+uuid);
        }else{
            uuid=uuidv4()
            console.log('new uuid:'+uuid);
            localStorage.setItem(UUID,uuid)
        }
        // app.actions.setUuid(uuid)
    },
    methods:{
        back(){
            this.$router.back()
        }
    }
}
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
